<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Campos</h3>
      </div>

      <p class="text-base my-3">
        Selecione os campos que deseja que apareça no relatório:
      </p>

      <!-- Campos selecionados -->
      <div
        class="vx-row flex items-center mt-2"
        v-if="listCamposSelecionados.length > 0"
      >
        <div class="vx-col flex-col">
          <vs-chip
            v-for="item in listCamposSelecionados"
            :key="item.campo"
            @click="removeCampo(item)"
            closable
            >{{ item.label }}
          </vs-chip>
        </div>
      </div>

      <div class="flex flex-col gap-3 m-2">
        <!-- Botão Lista de Campos -->
        <vs-button
          @click="modalCampos = true"
          color="primary"
          type="border"
          icon="list"
          class="w-full"
          >Lista de Campos
        </vs-button>

        <!-- Botão Excluir Todos -->
        <vs-button
          color="danger"
          icon="delete"
          type="border"
          class="w-full"
          @click="limpaCampos()"
          v-if="listCamposSelecionados.length > 0"
          >Excluir todos
        </vs-button>
      </div>
    </vs-card>

    <!-- Modal Campos -->
    <Modal
      title="Lista de Campos"
      :active.sync="modalCampos"
      @close="limpaPesquisa()"
    >
      <!-- Lista Campos -->
      <div class="vx-row flex flex-col-reverse lg:flex-row">
        <div class="vx-col lg:w-1/2 my-2">
          <div
            v-for="(subArray, index) in listCamposLocal"
            :key="index"
            class="my-5 mx-2"
          >
            <h5>
              <a>{{ subArray[0].label.charAt(0).toUpperCase() }}</a>
            </h5>
            <hr />

            <ul>
              <li
                v-for="item in subArray"
                :key="item.label"
                class="my-2"
                v-if="item.exibir"
              >
                <vs-checkbox v-model="listCamposSelecionados" :vs-value="item">
                  {{ item.label }}
                </vs-checkbox>
              </li>
            </ul>
          </div>
        </div>

        <!-- Pesquisar -->
        <div class="vx-col w-1/2 my-5">
          <vs-input
            class="sticky top-0"
            icon="search"
            label-placeholder="Pesquisar"
            @keyup="pesquisar"
            v-model="termoPesquisa"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../../../../../components/Modal.vue';
import notify from '../../../../../utils/notify';

export default {
  props: ['listCampos', 'camposFavoritos'],

  components: {
    Modal
  },

  watch: {
    listCampos() {
      this.preparaCampos();
    },

    listCamposSelecionados(value) {
      this.$emit('camposSelecionados', value);
    },

    camposFavoritos(value) {
      this.listCamposSelecionados = [];
      const listCamposSemSubArrays = this.listCamposLocal.flat();

      value.forEach((campo) => {
        const result = listCamposSemSubArrays.find(
          (item) => item.campo == campo,
        );

        this.listCamposSelecionados.push(result);
      });
    },
  },

  data() {
    return {
      listCamposLocal: [],
      listCamposSelecionados: [],
      modalCampos: false,
      termoPesquisa: '',
    };
  },

  methods: {
    pesquisar() {
      const termo = this.termoPesquisa.toLowerCase().trim();
      this.listCamposLocal.forEach((subArray) => {
        subArray.forEach((item) => {
          const label = item.label.toLowerCase();
          item.exibir = termo === '' || label.includes(termo);
        });
      });
    },

    limpaPesquisa() {
      this.termoPesquisa = '';
      this.listCamposLocal.forEach((subArray) => {
        subArray.forEach((item) => {
          item.exibir = true;
        });
      });
    },

    removeCampo(item) {
      const index = this.listCamposSelecionados.indexOf(item);
      this.listCamposSelecionados.splice(index, 1);
    },

    limpaCampos() {
      this.listCamposSelecionados = [];
    },

    exibeCamposSelecionados() {
      let nomesCampos = '';
      this.listCamposSelecionados.forEach((item) => {
        nomesCampos = nomesCampos + item.label + ', ';
      });
      return nomesCampos;
    },

    preparaCampos() {
      this.listCamposLocal = this.listCampos.map((subArray) => {
        return subArray.map((item) => {
          return { ...item, exibir: true };
        });
      });
    },
  },

  mounted() {
    this.preparaCampos();
  },
};
</script>

<style>
.headerStyle {
  border-bottom: 1px dotted rgba(var(--vs-primary), 1);
  color: rgba(var(--vs-primary), 1);
}
</style>
